import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bed90f96"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bed90f96&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bed90f96')) {
      api.createRecord('bed90f96', component.options)
    } else {
      api.reload('bed90f96', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bed90f96", function () {
      api.rerender('bed90f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/playConfig/templateConfig/index.vue"
export default component.exports